// src/views/letters/components/LetterSlot.tsx
// Kopia src/views/kiddo-games/letters/components/LetterSlot.tsx — tylko dla Literuj Regular
import React, { FC, memo } from 'react';
import classes from '../LettersView.module.less';

interface LetterSlotProps {
  letter: string;
  isActive: boolean;
  isSpace?: boolean;
}

export const LetterSlot: FC<LetterSlotProps> = memo(({ letter, isActive, isSpace = false }) => {
  const isFilled = letter || isSpace;

  return (
    <div
      className={`${classes.letterSlot} ${isActive ? classes.letterSlotActive : ''} ${
        isFilled ? classes.letterSlotFilled : ''
      } ${isSpace ? classes.letterSlotSpace : ''}`}
    >
      {isSpace ? '' : letter || '_'}
    </div>
  );
});
